import styled from 'styled-components';
import { Link } from 'gatsby';
import { animateIn, media } from '../../utils';

export const Wrapper = styled.div`
	h1 {
		text-align: center;
	}

	.gatsby-image-wrapper {
		height: 100%;
	}
`;

export const Cards = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
	gap: var(--gap);
	max-width: 1200px; /* Keeps your overall blog container from getting too wide on large monitors */
	margin: 0 auto; /* Centers the grid on the page */
	${animateIn('0.1s')} /* Fades in almost instantly */

	${media.xlarge`
		gap: calc(var(--gap) * 2);
	`}
`;

export const Card = styled(Link)`
	display: flex;
	flex-direction: column;
	height: 100%; /* <-- This ensures every card stretches to match the row's tallest tile */
	background-color: var(--cardBg);
	border-radius: var(--borderRadius);
	box-shadow: var(--level-1);
	overflow: hidden;
	text-decoration: none;
	color: inherit;
	transition:
		transform 0.3s ease,
		border-color 0.3s ease,
		box-shadow 0.3s ease;

	&:hover,
	&:focus {
		transform: translateY(-4px);
		box-shadow: var(--level-5);

		h2 {
			color: #38bdf8;
		}
	}
`;

export const ThumbnailWrapper = styled.div`
	width: 100%;
	aspect-ratio: 16 / 9;
	overflow: hidden;
	background-color: #111827;
	position: relative; /* Required for absolute positioning of the overlay */
	transition: transform 0.3s ease;

	/* Dark overlay */
	&::after {
		content: '';
		position: absolute;
		inset: 0;
		background-color: rgba(
			0,
			0,
			0,
			0.25
		); /* Adjust opacity here: 0.25 is a nice subtle tint */
		mix-blend-mode: multiply; /* Blends naturally with the image colors */
		transition: background-color 0.3s ease;
		z-index: 1;
		pointer-events: none; /* Lets clicks pass right through */
	}

	/* Optional: Make the overlay slightly lighter/clearer when hovering the card */
	${Card}:hover &::after {
		background-color: rgba(0, 0, 0, 0.1);
	}

	${Card}:hover & {
		transform: scale(1.03);
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const CardContent = styled.div`
	padding: 1.5rem;
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	flex-grow: 1;
`;

export const CardDate = styled.span`
	font-size: 0.85rem;
	color: #9ca3af; /* Muted gray */
	font-weight: 500;
`;

export const CardTitle = styled.h2`
	margin: 0;
	font-size: 1.25rem;
	font-weight: 700;
	color: #f9fafb; /* Bright white */
	line-height: 1.4;
	transition: color 0.2s ease;
`;

export const CardExcerpt = styled.p`
	margin: 0;
	font-size: 0.95rem;
	line-height: 1.5;
	color: #d1d5db; /* Soft light gray for readability */
	display: -webkit-box;
	-webkit-line-clamp: 3; /* Limits excerpt to 3 lines */
	-webkit-box-orient: vertical;
	overflow: hidden;
`;

export const TagList = styled.div`
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
	margin-top: auto; /* Pushes tags to the bottom if cards have uneven heights */
	padding-top: 0.5rem;
`;

export const Tag = styled.span`
	font-size: 0.75rem;
	font-weight: 600;
	padding: 0.2rem 0.6rem;
	background-color: #374151;
	color: #93c5fd;
	border-radius: 4px;
`;
